/* eslint-disable kf/const-naming-convention */
import { FLOW_TYPE } from "../../constants/metadata.constants";
import { serializeQueryParams } from "../../libs/services/utils";
let accountId;

export function getAccountId() {
  if (!accountId) {
    accountId = window.accountDetails._id;
  }
  return accountId;
}

export function getUploadBaseUrl() {
  return `/upload/2/${getAccountId()}/`;
}

export const FieldURLMapping = {
  Select: getList,
  Multiselect: getList,
  Checkbox: getList,
  User: getLookup,
  UserAndGroup: getLookup,
  MultiUser: getLookup,
  Reference: getLookup,
  RemoteLookup: getRemoteLookupData,
  JSON: getRemoteLookupData,
  Image: fielPrefix,
  Attachment: fielPrefix,
  SmartAttachment: fielPrefix,
  Signature: fielPrefix,
  Text: getRemoteLookupData,
  XML: getRemoteLookupData
};
function getList({ baseUrl, field, tableId, tableRowId, config = {} }) {
  let datasourceType =
    field["DatasourceType"] ||
    (field.getValue && field.getValue("DatasourceType"));
  let fieldId = field.id || field.Id;
  let param = {};
  let url = "";
  if (tableId && tableRowId) {
    url = `${baseUrl}/${tableId}/${tableRowId}/${fieldId}/dropdown`;
  } else {
    url = `${baseUrl}/${fieldId}/dropdown`;
  }
  if (
    datasourceType === FLOW_TYPE.DATASET ||
    datasourceType === FLOW_TYPE.FORM
  ) {
    let { pageNo = 1, queryStr = "", pageSize = 50 } = config;
    param = { q: queryStr, page_number: pageNo, page_size: pageSize };
  }
  return serializeQueryParams(url, param);
}

function getLookup({ baseUrl, field, config = {}, tableId, tableRowId }) {
  let { pageNo = 1, queryStr = "", pageSize = 50 } = config;
  let fieldId = field.id || field.Id;
  let param = { q: queryStr, page_number: pageNo, page_size: pageSize };
  let url = "";
  if (tableId && tableRowId) {
    url = `${baseUrl}/${tableId}/${tableRowId}/${fieldId}/lookup`;
  } else {
    url = `${baseUrl}/${fieldId}/lookup`;
  }
  return serializeQueryParams(url, param);
}

function getRemoteLookupData({ baseUrl, field, tableId, tableRowId }) {
  let fieldId = field.id || field.Id;
  if (tableId && tableRowId) {
    return `${baseUrl}/${tableId}/${tableRowId}/${fieldId}/rlookup?q=&page_number=1&page_size=50&`;
  } else {
    return `${baseUrl}/${fieldId}/rlookup?q=&page_number=1&page_size=50&`;
  }
}

function fielPrefix({ baseUrl = "", field, tableId, tableRowId }) {
  let url = baseUrl.split("/");
  // /process/2/ActgXu3D0zMg/Mock_Form/Pk8aB4V32FJAX/PkAbB4V32T81H
  // ["", "process", "1", "ActgXu3D0zMg", "Mock_Form", "Pk8aB4V32FJAX", "PkAbB4V32T81H"]
  let flowId, instanceId, activityInstance, baseKey;
  flowId = url[4];
  instanceId = url[5];
  if (url[1] === "process") {
    activityInstance = url[6];
    baseKey = `${flowId}/${instanceId}/${activityInstance}`;
  } else {
    baseKey = `${flowId}/${instanceId}`;
  }
  if (tableId && tableRowId) {
    return `${baseKey}/${tableId}/${tableRowId}`;
  } else if (tableId && tableRowId === "") {
    return `${baseKey}/${tableId}`;
  } else {
    return `${baseKey}`;
  }
  // return data;
}
